<div class="aarni-font relative block mt-[80px]">
    <picture>
        <source media="(min-width:1024px)" srcset="assets/img/admission-desktop-banners/OverView.webp">
        <source media="(min-width:768px)" srcset="assets/img/admission-desktop-banners/medium-screen/OverView.webp">
        <img
            src="assets/img/admissions-mobile-banners/OverView.webp"
            alt="Faculty Banner"
            class="w-full h-auto"
        >
    </picture>
</div>


<section class="bg-gray-100 py-6 aarni-font hidden lg:block">
    <div class="max-w-6xl mx-auto flex items-center justify-between px-4">
        <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8 text-center w-full">
            <div *ngFor="let stat of stats" class="flex flex-col items-center">
                <div class="w-14 h-14 flex items-center justify-center rounded-full" [ngClass]="stat.bgColor">
                    <i [class]="stat.icon + ' text-white text-2xl'"></i>
                </div>
                <h3 class="font-bold text-lg mt-2">{{ stat.number }}</h3>
                <p class="text-gray-600 text-sm">{{ stat.text }}</p>
            </div>
        </div>
    </div>
</section>

<div class="flex items-start justify-center p-4 bg-gray-50 aarni-font">
    <div class="flex flex-col lg:flex-row gap-4 p-4 w-full max-w-7xl">
        <aside class="w-full lg:w-1/4 space-y-4 lg:h-[950px] lg:overflow-y-auto">
            <div class="border-t-8 border-blue-400">
                <div class="bg-white shadow border border-gray-300">
                    <h2 class="text-lg font-bold p-4">Applying to ARNI</h2>
                    <div>
                        <a
                            href="/admissions/overview"
                            [ngClass]="{
            'bg-blue-600 text-white border-blue-400': isActive('/admissions/overview'),
            'text-blue-600 hover:bg-blue-400 hover:text-white hover:border-blue-400': !isActive('/admissions/overview')
          }"
                            class="flex items-center space-x-2 p-3 w-full cursor-pointer border-y border-gray-300 transition duration-300"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>Overview</span>
                        </a>

                        <a
                            *ngFor="let link of [
            { href: '/admissions/campus-virtual-tour', label: 'Campus Virtual Tour' },
            { href: '/admissions/criteria', label: 'Admission Criteria' },
            { href: '/admissions/flow', label: 'Admission Flow' },
            { href: '/admissions/program-fee', label: 'Program Fees' },
            { href: '/admissions/hostel-fee', label: 'Accommodation & Hostel' },
            { href: '/admissions/transportation-fee', label: 'Transportation Services' },
            { href: '/admissions/scholarship', label: 'Scholarship Opportunities' },
            { href: '/admissions/innovative-idea-scholarship', label: 'Innovative Idea Grants' },
            { href: '/admissions/fee-structure-for-previous-year-students', label: 'Fee Structures for Previous Year Students' },
            { href: '/admissions/education-loan-assistance', label: 'Education Loan Support' },
            { href: '/admissions/how-to-apply', label: 'How to Apply' },
            { href: '/quick-links/contact-us', label: 'Counseling Services' },
            { href: '/admissions/payment-procedure', label: 'Payment Procedure' },
            { href: '/admissions/refund-policy', label: 'Refund Policy' },
            { href: '/admissions/avenues-for-success', label: 'Avenues for Success@ARNI' },
            { href: '/admissions/lateral-entry-or-migration', label: 'Lateral Entry/Migration' },
            { href: '/admissions/faqs', label: 'FAQs' }
          ]"
                            [href]="link.href"
                            [ngClass]="{
            'bg-blue-600 text-white border-blue-400': isActive(link.href),
            'text-blue-600 hover:bg-blue-400 hover:text-white hover:border-blue-400': !isActive(link.href)
          }"
                            class="flex items-center space-x-2 p-3 w-full cursor-pointer border-b border-gray-300 transition duration-300"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>{{ link.label }}</span>
                        </a>
                    </div>
                </div>
            </div>
        </aside>
        <section class="flex-1 shadow-lg p-4 border-2 border-gray-200 bg-white text-justify">
            <h1 class="text-2xl font-bold mb-4">Admission in ARNI</h1>
            <h2 class="text-xl font-semibold mb-2">Overview</h2>
            <p class="text-gray-800">
                Under the Act No. 23 of 2009, ARNI was established by the state government of Himachal Pradesh, and it
                is approved by the University Grants Commission (UGC) under section 2(f) of the UGC Act, 1956. ARNI
                offers an online and offline admission process for prospective students. Applicants are encouraged to
                apply online through the official website by following a few simple steps, or visit the university
                campus to get immediate assistance.
            </p>
            <p class="mt-2 text-gray-800">
                To make the admission process streamlined and simple for the students, it has a comprehensive Admission
                Management System. The university provides a diverse range of undergraduate, postgraduate, and doctoral
                programs across various disciplines, ensuring a comprehensive educational experience. We have a team of
                professional and passionate faculty members who have a niche to transform society and mentor students in
                the right direction.
            </p>
            <p class="mt-2 text-gray-800">
                A rise in self-confidence is one of the main benefits of attending college. The intriguing thing is that
                you are an amateur when you initially enroll in college, but by the end of your last year, your
                personality has changed significantly. You become more knowledgeable, build strong networks, and get
                exposure to the industry. Confidence grows organically when you study at ARNI University.
            </p>
            <p class="mt-2 text-gray-800">We promise, you will join this university as a student, but leave as a responsive individual
                who has a
                flair to come as an asset to society!
            </p>

            <h2 class="text-xl font-semibold mt-4">Why Choose ARNI?</h2>
            <ul class="list-disc pl-6 mt-2 space-y-2 text-gray-800">
                <li><span class="font-semibold">UGC-Recognized Institution –</span> The University is recognized by UGC, ensuring that all the
                    degrees/certificates awarded are completely valid and acceptable around the world.
                </li>
                <li><span class="font-semibold">Strategic Location –</span> With peaceful and calm surroundings that motivate students to concentrate, ARNI
                    is situated in Kathgarh, Kangra, ensuring a serene and focused academic environment.
                </li>
                <li><span class="font-semibold">Industry-Aligned Curriculum –</span> 100+ courses are offered by the university, designed by industry
                    experts and scholars to provide thorough knowledge and skills.
                </li>
                <li><span class="font-semibold">Experienced Faculty –</span> With a team of 150+ highly passionate professors and teachers, we are on a
                    mission to provide academic excellence for student success.
                </li>
                <li><span class="font-semibold">Comprehensive Infrastructure –</span> ARNI University provides advanced facilities, including modern
                    laboratories, libraries, and Wi-Fi-enabled campuses to support effective learning.
                </li>
                <li><span class="font-semibold">Focus on Skill Development –</span> Apart from the textbook learning, we emphasize skills development by
                    organizing training sessions, experimental learning, and internships to enhance employability.
                </li>
                <li><span class="font-semibold">Diverse Academic Programs –</span> Offering a wide array of courses across disciplines such as Technology,
                    Management, Sciences, Humanities, and more, catering to varied student interests and career goals.
                </li>
                <li><span class="font-semibold">Supportive Learning Environment –</span> The university fosters a collaborative and inclusive atmosphere,
                    encouraging intellectual growth and personal development among students.
                </li>
            </ul>
            <p class="text-gray-800 mt-2">ARNI University is approved and recognized by HP-PERC, AIU, BCI, PCI, I.P.C, I.S.O, NCC, and NSS.
            </p>
            <p class="text-gray-800">For more information or to begin your application process, please visit our official website or contact
                our admission helpline at 1800-891-8962.
            </p>
        </section>
    </div>
</div>

<div class="bg-cover bg-center text-white p-10 aarni-font"
     style="background-image: url('assets/img/admissions/admission-overview-how-to-apply-bg.jpg');">
    <div class="max-w-6xl mx-auto text-center">
        <h2 class="text-3xl font-bold mb-12">How to Apply</h2>
        <div
            class="relative flex flex-col md:flex-row items-center justify-center space-y-10 md:space-y-0 md:space-x-12">
            <div class="absolute hidden md:block top-1/2 inset-x-1/4 border-t-2 border-teal-400"></div>
            <div
                class="text-center w-64 h-64 bg-teal-500 p-6 rounded-lg shadow-lg relative z-10 flex flex-col justify-between">
                <i class="fa fa-file-alt text-white text-5xl mx-auto mb-4"></i>
                <h3 class="text-lg font-bold">Step 1</h3>
                <p class="text-sm mt-2">Fill in The <span class="font-bold">Application Form</span></p>
            </div>
            <div
                class="text-center w-64 h-64 bg-teal-500 p-6 rounded-lg shadow-lg relative z-10 flex flex-col justify-between">
                <i class="fa fa-briefcase text-white text-5xl mx-auto mb-4"></i>
                <h3 class="text-lg font-bold">Step 2</h3>
                <p class="text-sm mt-2">
                    Confirm Program/Specialisation, <br>
                    <span class="font-bold">generate your System ID</span> and proceed to payment
                </p>
            </div>
            <div
                class="text-center w-64 h-64 bg-teal-500 p-6 rounded-lg shadow-lg relative z-10 flex flex-col justify-between">
                <i class="fa fa-id-card text-white text-5xl mx-auto mb-4"></i>
                <h3 class="text-lg font-bold">Step 3</h3>
                <p class="text-sm mt-2">
                    Get your Application Number on your <br>
                    <span class="font-bold">registered Email ID and Mobile Number</span>
                </p>
            </div>
        </div>
        <!-- <div class="mt-8 flex justify-center">
             <button (click)="downloadBrochure()"
                     class="bg-transparent border border-white text-white font-bold py-3 px-8 rounded-lg shadow-md hover:bg-white hover:text-teal-500 transition text-lg">
                 Download Brochure
             </button>
         </div>-->
    </div>
</div>

<section class="max-w-6xl mx-auto py-10 px-4 aarni-font">
    <h2 class="text-2xl font-bold text-black text-center">
        Who Can Apply at ARNI University?
    </h2>
    <p class=" text-center mt-2 text-gray-800">
        One of the biggest boosts from college is an increase in self-confidence.
        As you study at ARNI University, your personality grows along with your knowledge and networking skills.
    </p>
    <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 mt-8">
        <div *ngFor="let student of students" class="text-center">
            <div class="overflow-hidden">
                <img [src]="student.image" alt="Student Image"
                     class="w-full h-52 object-cover transform transition duration-300 hover:scale-105">
            </div>
            <h3 class="font-bold text-lg mt-4">{{ student.title }}</h3>
            <a [href]="student.link" class="text-green-600 hover:text-green-800 text-sm font-medium">
                View {{ student.title }} Programs
            </a>
        </div>
    </div>
</section>

<!--<div class="bg-gray-100 py-10 aarni-font">
    <div class="max-w-6xl mx-auto px-4 md:flex gap-6">
        <aside class="w-full md:w-1/3 bg-white p-6 rounded-lg shadow">
            <ul class="space-y-4">
                <li *ngFor="let item of menuItems"
                    (click)="selectedItem = item"
                    class="flex items-center gap-4 p-3 rounded-lg cursor-pointer transition-all duration-200"
                    [class.bg-blue-100]="selectedItem === item">
          <span class="w-10 h-10 flex items-center justify-center rounded-full text-white text-xl"
                [ngClass]="item.color">
            <i [class]="item.icon"></i>
          </span>
                    <span class="font-semibold text-gray-700">{{ item.label }}</span>
                </li>
            </ul>
        </aside>
        <div class="w-full md:w-2/3 bg-white p-6 rounded-lg shadow">
            <h2 class="text-2xl font-bold text-gray-800">{{ selectedItem.label }}</h2>
            <p class="text-gray-600 mt-2">Select Program to see Overview</p>

            <select class="w-full p-3 border border-gray-300 rounded mt-4">
                <option *ngFor="let program of programs">{{ program }}</option>
            </select>
            <p class="text-gray-700 mt-4">{{ selectedItem.description }}</p>
            <div class="mt-4">
                <h3 class="font-semibold text-lg text-gray-800">Highlights:</h3>
                <ul class="list-disc pl-6 text-gray-700 mt-2 space-y-1">
                    <li *ngFor="let point of selectedItem.highlights">{{ point }}</li>
                </ul>
            </div>
        </div>
    </div>
</div>-->

<div class="bg-gray-100 py-10 aarni-font">
    <div class="max-w-6xl mx-auto px-4 relative">
        <h2 class="text-3xl font-bold text-center text-gray-900">
            Discover the Facilities at ARNI University
        </h2>
        <div class="flex justify-center mt-6 border-b border-gray-300">
            <button
                class="px-4 py-2 text-lg font-medium"
                [class.text-black]="activeTab === 'academic'"
                [class.text-gray-500]="activeTab !== 'academic'"
                [class.border-b-2]="activeTab === 'academic'"
                (click)="activeTab = 'academic'; currentIndex = 0;">
                Academic Facilities
            </button>
            <button
                class="px-4 py-2 text-lg font-medium ml-6"
                [class.text-black]="activeTab === 'campus'"
                [class.text-gray-500]="activeTab !== 'campus'"
                [class.border-b-2]="activeTab === 'campus'"
                (click)="activeTab = 'campus'; currentIndex = 0;">
                Campus Facilities
            </button>
        </div>
        <div class="relative mt-6 px-8">
            <button
                class="absolute left-5 -ml-8 top-1/2 transform -translate-y-1/2 bg-white rounded-full shadow-md w-12 h-12 flex items-center justify-center text-2xl z-50"
                (click)="prevSlide()"
                [disabled]="currentIndex === 0">
                <i class="fa fa-arrow-left text-blue-500"></i>
            </button>
            <div class="overflow-hidden relative">
                <div class="flex transition-transform duration-300"
                     [style.transform]="'translateX(-' + (currentIndex * 100) + '%)'">
                    <div *ngFor="let item of facilities[activeTab]" class="w-full sm:w-1/2 md:w-1/3 flex-shrink-0 px-3">
                        <div class="bg-white rounded-lg shadow overflow-hidden h-[350px] flex flex-col">
                            <img [src]="item.image" class="w-full h-40 object-cover">
                            <div class="p-4 flex-grow">
                                <h3 class="font-semibold text-lg">{{ item.title }}</h3>
                                <p class="text-gray-800 mt-2">{{ item.description }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <button
                class="absolute right-5 -mr-8 top-1/2 transform -translate-y-1/2 bg-white rounded-full shadow-md w-12 h-12 flex items-center justify-center text-2xl z-50"
                (click)="nextSlide()"
                [disabled]="currentIndex >= getMaxIndex()">
                <i class="fa fa-arrow-right text-blue-500"></i>
            </button>
        </div>
        <div class="text-center mt-6">
            <div class="text-center mt-6">
                <!--<button class="bg-green-500 text-white px-6 py-2 rounded-full font-semibold hover:bg-green-600" *ngIf="activeTab === 'academic'">
                    View All
                </button>
                <button class="bg-green-500 text-white px-6 py-2 rounded-full font-semibold hover:bg-green-600" *ngIf="activeTab === 'campus'">
                    View All
                </button>-->
                <a *ngIf="activeTab === 'academic'"
                   class="bg-green-500 text-white px-6 py-2 rounded-full font-semibold hover:bg-green-600"
                   href="/campus-life/academic-facilities">
                    View All
                </a>
                <a *ngIf="activeTab === 'campus'"
                   class="bg-green-500 text-white px-6 py-2 rounded-full font-semibold hover:bg-green-600"
                   href="/campus-life/campus-facilities">
                    View All
                </a>
            </div>
        </div>
    </div>
</div>

<div class="bg-gradient-to-r from-blue-400 to-blue-600 py-10">
    <div class="max-w-4xl mx-auto px-4 relative">
        <h2 class="text-2xl md:text-3xl font-bold text-center text-white mb-6">
            Listen From Our Star Performers
        </h2>
        <div class="relative flex items-center justify-center">

            <button
                class="absolute left-5 -ml-8 md:-ml-12 top-1/2 transform -translate-y-1/2 bg-white rounded-full shadow-md w-12 h-12 flex items-center justify-center text-black text-2xl z-50 focus:outline-none focus:ring-0"
                (click)="prevVideoSlide()"
                [disabled]="currentIndex1 === 0"
            >
                <i class="fa fa-arrow-left text-blue-500"></i>
            </button>
            <div class="overflow-hidden w-full max-w-2xl">
                <div
                    class="flex transition-transform duration-500 ease-in-out"
                    [style.transform]="'translateX(-' + (currentIndex1 * 100) + '%)'"
                >
                    <div *ngFor="let video of videos" class="flex-shrink-0 w-full">
                        <iframe
                            [src]="video"
                            class="w-full h-[300px] md:h-[400px] rounded-lg shadow-lg"
                            allowfullscreen
                        ></iframe>
                    </div>
                </div>
            </div>

            <button
                class="absolute right-5 -mr-8 top-1/2 transform -translate-y-1/2 bg-white rounded-full shadow-md w-12 h-12 flex items-center justify-center text-2xl z-50"
                (click)="nextVideoSlide()"
                [disabled]="currentIndex1 >= videos.length - 1">
                <i class="fa fa-arrow-right text-blue-500"></i>
            </button>
        </div>
    </div>
</div>

<div class="bg-blue-100 text-center font-sans py-12">
    <h2 class="text-xl md:text-2xl font-bold mb-4">Recruiters</h2>
    <div class="flex items-center justify-center gap-6 py-4">
        <!--  <button class="bg-white p-2 md:p-3 rounded-full shadow-md flex items-center justify-center"
                  (click)="prevRecruitSlide()">&#10094;
          </button>-->
        <div class="overflow-hidden w-[85%] sm:w-[90%] md:w-[80%] lg:w-[70%] flex items-center">
            <div class="flex gap-3 sm:gap-4 transition-transform duration-500 ease-in-out self-center"
                 [style.transform]="'translateX(-' + (index * 120) + 'px)'">
                <div *ngFor="let recruiter of recruiters"
                     class="min-w-[100px] sm:min-w-[120px] p-2 sm:p-3 bg-white shadow-md rounded flex items-center justify-center">
                    <img [src]="recruiter.logo" [alt]="recruiter.name"
                         class="max-w-[80px] sm:max-w-[100px] h-auto">
                </div>
            </div>
        </div>
        <!--  <button class="bg-white p-2 md:p-3 rounded-full shadow-md flex items-center justify-center"
                  (click)="nextRecruitSlide()">&#10095;
          </button>-->
    </div>
    <!-- <button class="mt-4 bg-blue-500 text-white px-4 sm:px-6 py-2 rounded-full">View all</button>-->
</div>
